<template>
  <div class="wrapper">
    <div @click="gzhLikeShow=true" v-if="wechatLikeSwitch==1&&wechatSubscribe==0" class="gzhWechat">
      <div class="left">
        <div @click.stop="wechatSubscribe=1" class="closeC">
          <img class="close" src="../../assets/images/index/close1.svg" alt="">
        </div>
        <img class="gzhImg" :src="cdnImgPath + '/images/default/gzh_logo.jpg'" alt="">
        <div class="des">
          <span>关注公众号，享专属服务</span>
        </div>
      </div>
      <div class="right">
        <div class="likeBtn">
         立即关注
        </div>
      </div>
    </div>
    <div class="home-search" :style="{background: stopBg?'#E52B25':bgColor}">
      <router-link :to="'/searchlist?supNbr=' + userInfo.nbr" class="searchBox">
        <div class="home-top-search">
          <img src="../../assets/images/search2.png" alt>
          <span>请输入商品或品牌名称</span>
        </div>
      </router-link>
      <div class="credentialBox" @click="linkTo('credential')">
        <img src="../../assets/images/index/credentialIcon.png" alt />
        <span>平台资质</span>
      </div>
      <div class="message">
        <div class="radius" v-if="hasMessage>0">{{hasMessage>99?'99+':hasMessage}}</div>
        <img @click="linkTo('myNotice')"  src="../../assets/images/index/message.png" alt />
      </div>
    </div>

    <!--秒杀-->
    <div class="msTop" id="msTop"  v-if="msShow&&starttime.length>0&&offShelf&&priceArea.length>0">
      <div :class="{msTopItem:true,active:seckillIndex==0}" @click.stop="fixedMsClick(0)">
        <span>今日爆品</span>
      </div>
      <div :class="{msTopItem:true,active:seckillIndex==1}" @click.stop="fixedMsClick(1)">
        <span>即将下架</span>
      </div>
    </div>

    <!--秒杀分享-->
    <div class="msShareTop" v-if="msShow&&starttime.length>0&&seckillIndex==0" @click.stop="toMsAreaShare">
      <img src="../../assets/images/index/msShare.png" />
      <span>分享专区</span>
    </div>

    <van-pull-refresh :disabled="noticeShow" v-model="isLoading" @refresh="refresh" id="refresh2">
        <div class="home-top-banner">
        <div class="home-top-banner-bg" :style="{background: stopBg?'#E52B25':bgColor}"></div>
        <div class="swiper-top">
          <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(slide ,i) in slides"  :key="i">
                 <img :src="slide.image_path" alt="">
              </div>
           </div>
           <div class="propagation" @click="linkTo('login')">
            <div :class="swipeIndex==i?'item active':'item'" v-for="(slide ,i) in slides"></div>
          </div>
         </div>
      </div>
      <!-- 轮播 -->

      <!-- 客服时间 -->
      <van-notice-bar class="serverTime" id="serverTime"
        :left-icon="require('../../assets/images/index/kfNotice.png')"
        color="#333333"
        :text="noticeStr"
        v-if="noticeStr"
        @click="noticeShow = true"
      />
      <van-popup v-model="noticeShow" :close-on-click-overlay="false" style="background:transparent">
        <div class="noticeBox">
          <div class="title">公告通知</div>
          <div class="contentArea">
            <div class="content"><span>{{noticeObj.contents}}</span></div>
             <img v-if="noticeObj.image_url" @click="showImage(noticeObj.image_url)" :src="noticeObj.image_url" alt="">
          </div>
          <div class="checkBtn" @click="noticeShow = false">我知道了</div>
        </div>
     </van-popup>

     <div class="rankBox" v-if="is_show_list_in_home=='1'">
      <img src="../../assets/images/rank/hotRanking.png" alt="" @click="toRank('1')">
      <img src="../../assets/images/rank/liveRanking.png" alt="" @click="toRank('2')">
     </div>

      <div class="home-top-class" v-if="menuArr.length>0">
        <div class="home-top-classl" @click="menuClick(item)" v-for="(item,index) in menuArr" :key="index">
          <div class="home-top-classlt">
            <img :src="item.image_path" alt>
          </div>
          <div class="home-top-classlb">{{item.name}}</div>
        </div>
      </div>

      <div class="line" v-if="couponCenterObj.state==0"></div>
      <div class="scoreSign" @click="linkTo('securities')" v-if="couponCenterObj.state==0">
        <img :src="couponCenterObj.banner_path" alt="">
      </div>
      <div class="line" v-if="newShow"></div>
      <!-- 新人专享 -->
      <div class="home-area" v-if="newShow">
        <div class="title" style="box-shadow:none">
          <div class="titlebox">
            <div class="imgbox">
              <img src="../../assets/images/index/newArea.png" />
            </div>
            <div class="titletext">
              <span>新人专享</span>
            </div>
          </div>
          <div class="right" @click="toNewArea">
            <div class="more" >查看更多</div>
            <img src="../../assets/images/Arrow.png"/>
          </div>
        </div>
        <div class="newAreaBg" @click="toNewArea">
          <img src="../../assets/images/index/newAreaBg.jpg" alt="">
        </div>
      </div>
      <!-- 直播列表 -->
      <div class="line" v-if="liveList.length > 0"></div>
      <div class="home-content-supervalue" v-if="liveList.length > 0">
        <div class="home-content-t-supervalue">
          <div class="home-content-tl-supervalue">
            <div class="home-content-supervaluell">
              <img src="../../assets/images/index/live_group.png"/>
            </div>
            <div class="home-content-supervaluel">
             直播
            </div>
          </div>
          <div @click="toMoreLive" class="home-content-more-supervaluel">
            <div class="home-content-title-supervaluel" >更多直播</div>
            <img src="../../assets/images/Arrow.png"/>
          </div>
        </div>
        <div class="liveList">
          <div class="liveListItem" v-for="(item,index) in liveList" :key="index" @click="toLive(item, index)">
            <div class="liveTop" v-if="item.live_status=='101'">直播中</div>
            <div class="liveTop" v-if="item.live_status=='102'">未开始</div>
            <div class="liveTop" v-if="item.live_status=='103'">结束直播</div>
            <div class="liveTop" v-if="item.live_status=='104'">禁止</div>
            <div class="liveTop" v-if="item.live_status=='105'">暂停</div>
            <div class="liveTop" v-if="item.live_status=='106'">异常</div>
            <div class="liveTop" v-if="item.live_status=='107'">已过期</div>
            <img class="liveImg" :src="item.show_img_url||item.cover_img" alt="">
            <div class="liveBottom">
              <div class="text sigle-h">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="seckillWrap" id="seckillWrap" v-if="((starttime.length>0)||offShelf)&&priceArea.length>0">
        <!-- <div class="seckillTabWrap"></div> -->
        <div class="seckillTabWrap" v-if="starttime.length>0&&offShelf">
          <div :class="seckillIndex==0?'seckillTabLeft0':'seckillTabLeft1'" @click="changeSeckill(0) ">
            <div class="title">
               <span>今日爆品</span>
            </div>
            <div class="fixed">
              <div class="lateral-sliding" id="lateralScroll">
                <div :id="'lateralItem'+index" class="lateral-sliding-item" v-for="(item,index) in starttime" :key="index" v-if="starttime[0].start_time&&starttime.length>0">
                  <div :class="index==isindex  ? 'each-img' : 'each-img-x'" @click="chuxian(index) ">
                    <span class="each-img-span">{{item.start_time}}</span>
                    <div class="each-img-span1">
                      <span v-if="item.isEnd == true">已结束</span>
                      <span v-else-if="item.timeText == true">抢购中</span>
                      <span v-else>即将开抢</span>
                    </div>
                    <div class="active">
                      <img src="../../assets/images/index/seckillSign.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="seckillIndex==0?'seckillTabRight0':'seckillTabRight1'" @click="changeSeckill(1)">
            <div class="title">
              <span>即将下架</span>
            </div>
            <div class="otherTab">
              <span>中午12:00下架</span>
            </div>
          </div>
        </div> 

        <div class="onlySeckillTab" v-else>
          <div class="title" :style="seckillIndex==0?'margin-top:.14rem':'margin-top:.26rem'">
            <img src="../../assets/images/index/seckillTip.png" alt="">
            <span>{{seckillIndex==0?'今日爆品':'即将下架'}}</span>
            <img style="transform: rotate(180deg);" src="../../assets/images/index/seckillTip.png" alt="">
          </div>
          <div class="fixed" v-if="seckillIndex==0">
            <div class="lateral-sliding" id="lateralScroll">
              <div :id="'lateralItem'+index" class="lateral-sliding-item" v-for="(item,index) in starttime" :key="index" v-if="starttime.length>0">
                <div :class="index==isindex  ? 'each-img' : 'each-img-x'" @click="chuxian(index) ">
                  <span class="each-img-span">{{item.start_time}}</span>
                  <div class="each-img-span1">
                    <span v-if="item.isEnd == true">已结束</span>
                    <span v-else-if="item.timeText == true">抢购中</span>
                    <span v-else>即将开抢</span>
                  </div>
                  <div class="active">
                    <img src="../../assets/images/index/seckillSign.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="otherTab">
            <span>中午12:00下架</span>
          </div>
        </div>
        
      </div>
      <div class="homeList" v-if="seckillIndex==0&&priceArea.length>0">
        <van-list
          v-model="seckillLoading"
          :finished="seckillFinished"
          @load="getSeckillData"
          :offset="20"
        >
          <div
            class="home-content-jm"
            v-for="(item,index) in priceArea"
            :key="index"
            @click="golistdetail(item.nbr, item.rule_type)"
          >
            <div class="home-content-jml" v-if="priceArea.length > 0">
              <div class="img">
                <img v-lazy="item.commodity_rect_logo" alt>
              </div>
              <!-- <div :class="item.quantity==='0'?'noNum':'noNum hide'">
                <img v-lazy="require('../../assets/images/noNum.png')" alt>
              </div> -->
              </div>
            <div class="home-content-jmr">
              <div class="home-content-jmrt">{{item.commodity_name}}</div>
            <div>
              <div class="home-content-summary sigle-h" v-if="item.commodity_summary">{{item.commodity_summary}}</div>
            </div>
            <div>
              <div v-if="item.is_sales_show=='1'" class="home-content-summary-sales sigle-h">已抢{{item.show_sales_num}}件</div>
              <div v-else class="commoditySummarySales sigle-h"></div>
            </div>
              <!-- <div class="home-content-jmrm1 more-h" style=" -webkit-box-orient: vertical;"></div> -->
              <!-- <div class="progress" style="background: #fff;" v-if="starttime.length>0&&starttime[isindex].timeText == true">
                <div class="progressbg" :style="{width:parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100)  + '%'}">
                  <span v-show="parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) < 95">已抢{{parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100)}}%</span>
                  <span v-show="parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) < 100 && parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) >= 95">即将售罄</span>
                  <span v-show="(parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) >= 100)||item.quantity==0&&item.sales_num==0">已售罄</span>
                </div>
              </div> -->
              <!-- <div class="surplus" v-if="starttime[isindex].timeText == false">
                剩余{{item.quantity}}件 | 今天{{starttime[isindex].start_time}}开抢
              </div> -->
              <div class="home-content-jmrm2">
                <span class="msj">
                  <span v-if="item.rule_type=='2'">
                    <i>￥</i>{{roleNewText=='sell'&&item.show_price?item.show_price:item[`min_${roleNewText}_price`]}}
                  </span>
                  <span v-else>
                    <i>￥</i>{{roleText=='sell'&&item.show_price?item.show_price:item[`min_${roleText}_price`]}}
                  </span>
                  <span v-if="parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2)) != 0">
                    <!--/ 赚{{parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2))}}-->
                  </span>
                </span>
                <span class="msj1" v-if="seckillIndex==1||(starttime.length>0&&starttime[isindex].timeText == true&& item.quantity > 0)" @click="golistdetail(item.nbr, item.rule_type)">
                  <span style="margin-left:.1rem">
                    去抢购
                    <img src="../../assets/images/index/back.svg" />
                  </span>
                </span>
                <span @click.stop="noticeThis(item.nbr,index)" class="msj1 msj2" v-else-if="starttime.length>0&&starttime[isindex].timeText == false && (item.warn==0||isLogin == 0)">
                  <span>设置提醒</span>
                </span>
                <span style="background:#ccc" class="msj1 msj2" v-else-if="starttime.length>0&&starttime[isindex].timeText == false && item.warn!=0">
                  <span>已设置</span>
                </span>
                <span class="msj1" v-else-if="item.quantity == 0">
                  <span>查看</span>
                </span>
                <span class="msj1 msj3" @click.stop="goMsShare(index)">
                  <span class="text">去分享</span>
                </span>
              </div>
              <div class="home-content-jmrb">
                <span>
                  ￥{{item.old_price}}
                </span>
              </div>
            </div>
            <div class="home-content-jml-no" v-if="priceArea.length ==0">
              <span>该场秒杀已结束</span>
            </div>
          </div>
        </van-list>
      </div>
      <div class="homeList" v-if="seckillIndex==1&&priceArea.length>0">
        <van-list style="background:transparent" v-model="seckillLoading" :finished="seckillFinished" @load="getSeckillData" :offset="20">
          <div class="tabbox">
            <div class="tabboxm" v-for="(item,index) in priceArea" :key="index" @click="golistdetail(item.nbr, item.rule_type)">
              <div class="tabboxmt">
                <img class="img" v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt="">
                <div :class="item.quantity==='0'?'noNum':'noNum hide'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt="">
                </div>
                <img class="sales" v-if="item.start_state==0" src="../../assets/images/beSale.png" alt="">
              </div>
              <div class="border"></div>
              <div class="tanboxmm1 sigle-twoh">
                {{item.commodity_name}}
              </div>
              <div>
              <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:null">{{item.commodity_summary}}</div>
              </div>
              <div> 
                <div v-if="item.is_sales_show=='1'"class="commoditySummarySales sigle-h" style="background:#EEF7FF">已抢{{item.show_sales_num}}件</div>
                <div v-else class="commoditySummarySales sigle-h"></div>
              </div> 
              <div class="tanboxmb">
                <span class="bold" v-if="item.rule_type=='2'"><i>￥</i>{{roleNewText=='sell'&&item.show_price?item.show_price:item[`min_${roleNewText}_price`]}}<span v-if="Math.round((item[`min_sell_price`] - item[`min_${roleNewText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((item[`sell_price`] - item[`${roleNewText.toLowerCase()}_price`])*100)/100}}--></span>
              </span>
                <span class="bold" v-else><i>￥</i>{{roleText=='sell'&&item.show_price?item.show_price:item[`min_${roleText}_price`]}}<span v-if="Math.round((item[`min_sell_price`] - item[`min_${roleText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`])*100)/100}}--></span>
                </span>
              </div>
              
              <div class="couponbox">
                <span class="tanboxmbspan">￥{{item.old_price}}</span>
                <span :class="item.is_use_coupon=='0'?'coupon1 hide':'coupon1'">可用券</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div id="seckillEnd"></div>

      <div class="line" v-if="pagearea.length > 0"></div>
      <!-- 限时秒杀 -->
      <div class="home-area" v-if="pagearea.length > 0">
        <div class="title">
          <div class="titlebox">
            <div class="imgbox">
              <img src="../../assets/images/index/hua.png" />
            </div>
            <div class="titletext">
              <span>精选专场</span>
            </div>
          </div>
        </div>
        <hotArea
          id="hotArea"
          :pagearea='pagearea'
          :moreUrl="'explosive'"
          :roleText="roleText"
          :roleNewText="roleNewText"
          :isLogin="isLogin"
          class="pagearea"
          ref="hotArea"
        ></hotArea>
      </div>
      <div class="line" v-if="goods_classify.length > 0"></div>
      <div class="home-area" id="homeTab">
         <div class="title" v-if="goods_classify.length>0">
           <div class="titlebox">
            <div class="imgbox">
              <img src="../../assets/images/tuijian.png">
            </div>
            <div class="titletext">
              <span>好物推荐</span>
            </div>
          </div>
         </div>
          <van-list style="background:transparent" v-model="loading" :finished="finished" @load="getSecondArea" :offset="20">
           <div class="tabbox">
            <div class="tabboxm" v-for="(item,index) in goods_classify" :key="index" @click="golistdetail(item.nbr, item.rule_type)">
              <div class="tabboxmt">
                <img class="img" v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt="">
                <div :class="item.quantity==='0'?'noNum':'noNum hide'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt="">
                </div>
                <img class="sales" v-if="item.start_state==0" src="../../assets/images/beSale.png" alt="">
              </div>
              <div class="border"></div>
              <div class="tanboxmm1 sigle-twoh">
                {{item.commodity_name}}
              </div>
              <div>
                <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:null">{{item.commodity_summary}}</div>
              </div>
              <div>
                <div v-if="item.is_sales_show=='1'" class="commoditySummarySales sigle-h" style="background:#EEF7FF">已抢{{item.show_sales_num}}件</div>
                <div v-else class="commoditySummarySales sigle-h"> </div>
              </div> 
              <div class="tanboxmb">
                <span class="bold" v-if="item.rule_type=='2'"><i>￥</i>{{roleNewText=='sell'&&item.show_price?item.show_price:item[`${roleNewText}_price`]}}<span v-if="Math.round((item[`sell_price`] - item[`${roleNewText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((item[`sell_price`] - item[`${roleNewText.toLowerCase()}_price`])*100)/100}}--></span>
                </span>
                <span class="bold" v-else><i>￥</i>{{roleText=='sell'&&item.show_price?item.show_price:item[`${roleText}_price`]}}<span v-if="Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((item[`sell_price`] - item[`${roleText.toLowerCase()}_price`])*100)/100}}--></span>
                </span>
              </div>
              
              <div class="couponbox">
                <span class="tanboxmbspan">￥{{item.old_price}}</span>
                <span :class="item.is_use_coupon=='0'?'coupon1 hide':'coupon1'">可用券</span>
              </div>
            </div>
          </div>
          <div class="nomore" v-show="finished==true && goods_classify.length != 0"></div>
          </van-list>
    </div>
    <!--一级分类商品-->
    </van-pull-refresh>
    <!-- 平常优惠券弹窗 -->
    <div class="coupons-wrap" v-if="couponsshow" >
      <van-popup v-model="showcoupons" :lock-scroll="true" @click-overlay="couponsclose">
        <div class="coupons">
          <div class="couponsimg">
            <div class="couponsTitle">
              <img src="../../assets/images/index/couponsTitle.png" alt="">
              <div class="couponSpan"><span>新人<br>优惠券</span></div>
            </div>
            <div class="noticeTitle">点击立即领取马上获得您的专属优惠</div>
            <img class="couponsTop" src="../../assets/images/index/couponsTop.png" alt>
          </div>
          <div class="coupons-m-wrap">
            <div class="coupons-bottom">
               <div class="getBtn" v-if="getCoupons"><span>已领取</span></div>
               <div class="getBtn" @click="getcoupon" v-else><span>一键领取优惠券</span></div>
            </div>
            <div class="coupons-m-cotainer">
               <div class="coupons-m" v-for="(item,index) in coupon_list" :key="index">
              <div class="coupons-mr">
                <p>
                  ¥
                  <i>{{item.limit_amount}}</i>
                </p>
                <!-- <p v-if="item.coupon_listshow==0" @click="getcoupon(item.nbr,index)">立即领取</p>
                <p v-if="item.coupon_listshow==1">已领取</p> -->
              </div>
              <div class="coupons-ml">
                <p>{{item.name}}</p>
                <p v-if="item.limit_type != 0">订单满￥{{item.limit_condition}}可使用</p>
              </div>
              
             </div>

            </div>
          </div>
          <div class="coupons-close" @click="couponsclose">
              <img src="../../assets/images/icon_close2.svg" alt>
            </div>
        </div>
      </van-popup>
    </div>
    <!-- 优惠券弹窗 -->

    <!-- 首页弹窗 -->
    <div class="homePopupWrap" v-if="homePopupModal">
      <van-popup v-for="(item,index) in popupArr" :key="index" v-model="item.modalState" :lock-scroll="true" @click-overlay="closeHomePopup(item)">
        <div class="homePopupItem">
          <img class="homePopupItemImg" @click.stop="linkType(item)" :src="item.image_path" alt="">
          <div class="homePopupItemClose" @click.stop="closeHomePopup(item)">
            <img src="../../assets/images/index/homePopup_close.png" alt>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 我的群弹窗 -->
    <div class="groupWrap" v-if="groupModal" >
      <van-popup v-model="groupModal" :lock-scroll="true" @click-overlay="groupModal=false">
        <div class="groupBox">
          <img class="groupClose" src="./../../assets/images/icon_close.svg" alt  @click.stop="groupModal=false"/>
          <div class="groupDesc">{{groupInfo.contents}}</div>
          <img class="groupImg" :src="groupInfo.image" alt="">
          <div class="groupBtn"><span>长按识别二维码</span></div>
        </div>
      </van-popup>
    </div>

    <!-- 权益卡弹窗 -->
    <div class="equityWrap" v-if="equityModal" >
      <van-popup v-model="equityModal" :lock-scroll="true" @click-overlay="equityModal=false">
        <div class="equity">
          <img class="equityImg" src="../../assets/images/index/homeEquity.png" alt="">
          <div class="equityBtn" @click="linkTo('equityDetail')"><span>0元领</span></div>
          <div class="equity-close" @click="equityModal=false">
            <img src="../../assets/images/icon_close2.svg" alt>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 实时购买动态 -->
    <transition-group name="hehe" v-for="(news, index) in news" :key="index" v-show="index==newIndex">
      <span class="buy" v-if="buyshow" :key="index" @click="golistdetail(news.commodity_nbr, news.rule_type)">
        <img class="avatar" :src="news.head_pic"/><span>来自{{news.city}}的{{ news.nick_nam }}{{randomNum}}秒前下单</span>
        <img class="back" src="../../assets/images/index/back.svg" alt="">
      </span>
    </transition-group>
    <!-- 分享按钮 -->
    <div class="poBtnArea">
      <div class="toTurn" @click="gameClick" v-if="gameState==='0'">
        <img src="../../assets/images/homeTurn.png" />
      </div>
      <div class="share" style="width:1.22rem;height:1.22rem;margin-bottom:.2rem" @click="groupModal=true" v-if="(roleText=='agent'||roleText=='director')&&groupInfo.state=='0'">
        <img style="width:1.22rem;height:1.22rem" src="../../assets/images/index/homeGroup.png"/>
      </div>
      <div class="share" @click="btn" v-if="homeFullImg.length > 0">
        <img src="../../assets/images/index/home-share.png"/>
      </div>
      <div class="share" style="width:1.5rem;height:1.5rem;margin-top:.2rem" @click="equityModal=true" v-if="showEquity">
        <img style="width:1.5rem;height:1.5rem" src="../../assets/images/index/cardFixed.png"/>
      </div>
      <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
        <img src="../../assets/images/index/home-gotop.png" />
      </div>
    </div>
    <!-- 首页分享图 -->
    <div class="box">
     <van-popup v-model="show">
       <div>
         <div class="swiper-container" id="shareSwiper">
          <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item ,index) in homeFullImg"  :key="index" @click="btn1">
                <div class="swiper-img" :style="{background: '#ccc' }">
                 <img :src="item.mainImg" alt="" class="swiper-showImg">
                </div>
              </div>
          </div>
         </div>
       </div>
      </van-popup>
       <div class="hold" v-if="show">
          <div @click="wechatShareBtn1">
            <img src="../../assets/images/Sharing_Friends.png"/><br/>
            <span>分享好友</span>
          </div>
          <div @click="wechatShareBtn2">
            <img src="../../assets/images/Sharing_Friends2.png"/><br/>
            <span>分享朋友圈</span>
          </div>
          <div @click="downloadImg">
            <img src="../../assets/images/Save_pictures.png"/><br/>
            <a :dowanload="htmlUrl">下载图片</a>
          </div>
        </div>
    </div>
    <!-- 秒杀专区分享图 -->
    <div class="box1">
      <van-popup v-model="msShareAreaShow" @click-overlay="msColseshare" class="van-popup" style="width: 100%;">
        <div class="imgCotainer">
         <div class="shareBox" ref="shareBox">
           <img :src="msShareAeraImage || ''" alt="" class="shareImg" />
           <!-- <img :src="msShareImage[1] || ''" alt="" class="shareImg" /> -->
         </div>
        </div>
       </van-popup>
        <div class="hold" v-if="msShareAreaShow">
           <div @click="wechatShareBtn1">
             <img src="../../assets/images/Sharing_Friends.png"/><br/>
             <span>分享好友</span>
           </div>
           <div @click="wechatShareBtn2">
             <img src="../../assets/images/Sharing_Friends2.png"/><br/>
             <span>分享朋友圈</span>
           </div>
           <div @click="downloadImg">
             <img src="../../assets/images/Save_pictures.png"/><br/>
             <a>下载图片</a>
           </div>
         </div>
     </div>
    <!-- 秒杀商品分享图 -->
    <div class="box1">
     <van-popup v-model="msShareShow" @click-overlay="msColseshare" class="van-popup" style="width: 100%;">
       <div class="imgCotainer">
        <div class="shareBox" ref="shareBox">
          <img :src="msShareImage[0] || ''" alt="" class="shareImg" />
          <!-- <img :src="msShareImage[1] || ''" alt="" class="shareImg" /> -->
        </div>
       </div>
      </van-popup>
       <div class="hold" v-if="msShareShow">
          <div @click="wechatShareBtn1">
            <img src="../../assets/images/Sharing_Friends.png"/><br/>
            <span>分享好友</span>
          </div>
          <div @click="wechatShareBtn2">
            <img src="../../assets/images/Sharing_Friends2.png"/><br/>
            <span>分享朋友圈</span>
          </div>
          <div @click="downloadImg">
            <img src="../../assets/images/Save_pictures.png"/><br/>
            <a>下载图片</a>
          </div>
        </div>
    </div>
     <!-- 公众号二维码-->
     <van-popup class="gzhBox" v-model="gzhLikeShow">
       <div class="content">
         <img :src="cdnImgPath + '/images/default/gzh_qrcode.jpg'" alt="">
         <span>长按识别二维码关注公众号</span>
       </div>
     </van-popup>
     <!-- 小程序码-->
     <van-popup class="gzhBox" v-model="xcxCodeShow" style="overflow:hidden">
       <div class="content" style="background:#fff;border-radius:.2rem;padding:.3rem;box-sizing:border-box">
         <img :src="xcxCode" alt="">
         <span style="color:#333">长按识别小程序码</span>
       </div>
     </van-popup>
  </div>
</template>

<script>
import hotArea from "./hotArea";
import { mapGetters } from "vuex";
import { formatNickName,setCookie,getCookie,StandardNum, timestampconvert  } from "../../assets/js/tool";
import axios from "axios";
import weChatShareApi from "../../assets/js/weChatShare";
import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper';

export default {
  components: {
    hotArea: hotArea,
  },
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      slides: [],
      pagearea:[],
      recommend:[],
      announcement:[],
      menuArr:[],
      notice:[],//今日预告
      priceArea:[], // 秒杀价
      commodity:[],
      liveList:[], // 直播列表
      swipeIndex: 0, //轮播下标
      showcoupons: false, //优惠券弹窗
      couponsshow: false, //优惠券弹窗显隐
      ptshowcoupons: false, //普通优惠券弹窗
      ptcouponsshow: false, //普通优惠券弹窗显隐
      newShow: false, // 新人专区显隐
      first_classify: [], //商品一级分类
      goods_classify: [], //一级分类下的商品
      coupon_list: [], //优惠券
      ptcoupon_list: [], //优惠券
      // coupon_listshow:true,//立即领取优惠券
      superUserId: "", //扫码进入的值(一般商品)
      roleText: "sell", //用户身份文本
      roleNewText: "sell",
      loading: false, //上拉加载
      finished: false, //加载完成
      pageIndex: 0,
      numPerPage: 10,
      superpageIndex: 0,
      supernumPerPage: 6,
      isLoading: true,
      show:false,
      buyshow:true,
      news:[],
      shareSwitch:true,
      newIndex:-1,
      htmlUrl:[],//截图
      homeFullImg:[],
      swiper:null,
      userAvatar:'',
      userName:'',
      timeOut:null,
      timer:null, // 提示定时器
      timerOut:null, // 提示延迟器
      codeTimer: null, // 二维码定时器
      qrCode:'', // 二维码
      fans:{
        is_up_role:1,
        up_num:10,
      },
      randomNum:1, // 随机数
      toTopShow:false,
      scrollToptimer: null,
      swiperTop:null,
      list:[],
      list1:[],
      seckillPageIndex:0,
      seckillLoading: false,
      seckillFinished: false,
      seckillIndex:-1,
      starttime:[],
      offShelf:false,
      isindex: 0,
      widthNum:0,
      userPic:[],
      couponSwitch:false,
      getCoupons:false,
      scroll:0,
      isLogin:0, //是否登录？是否绑定手机号
      countdown: "",
      tomcountdown: "",
      claerTimer:null,
      thisIndex:'',
      isStart:0,
      movetimer:null,
      scrollLeft:0,
      indexLogin:false, // 是首页登录吗？
      mounted1:false,
      areaIndex:0,
      msShareAreaShow :false, // 秒杀专场分享图显隐
      msShareAeraImage:'', //秒杀专场分享图
      msShareShow:false, // 秒杀显隐
      msShareImage:[], //秒杀分享图
      msShareSwitch:true, //秒杀开关
      msQrCode:'', // 秒杀二维码
      //recommendShow:0, // 好物推荐显示
      shareUserNbr:'',
      jumpParam:{},
      wechatSubscribe:1,  //公众号关注状态
      subUserName:'', //推荐人昵称
      subUserImg:'', //推荐人头像
      gzhLikeShow:false,//公众号二维码
      wechatLikeSwitch:0, //关注开关
      show_word_version:0,
      xcxCodeShow: false,
      xcxCode:'',
      couponCenterObj:{},
      gameState:'',

      hasMessage:'0',
      noticeObj:{},
      noticeStr:'',
      noticeShow: false,
      msShow:false,
      stopBg:false,
      bgColor:'#E52B25',

      equityModal:false,
      showEquity:false,

      groupModal:false,
      groupInfo:{},

      homePopupModal:false,
      popupArr:[],
      is_show_list_in_home:'',
    }
  },
  watch:{
    coupon_list(newval, oldval) {
      this.coupon_list = newval;
    },
  },
  computed: {
    ...mapGetters(["agentText","directorText"])
  },
  methods: {
    msColseshare(){
      this.$toast.clear();
      this.msShareAreaShow = false;
      this.msShareShow = false;
      let option = {
        title: '有米@'+this.userInfo.name+'的店铺',
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
      this.weChatShare(option);
    },
    toRank(type){
      this.$router.push({path:'/rankList',query:{type:type}});
    },
    linkTo(url){
      this.$router.push({path:'/'+ url,query:{supNbr:this.userInfo.nbr}});
    },
    fixedMsClick(index){
      let seckillWrapTop = document.getElementById("seckillWrap").offsetTop;
      let clientHeight= document.getElementById("seckillWrap").clientHeight;
      let msHeight= document.getElementById("msTop").clientHeight;
      window.scrollTo(0,seckillWrapTop+clientHeight-msHeight);
      if(this.seckillIndex==index) return false

      this.seckillIndex=index
      //请求参数
      this.seckillPageIndex = 0
      this.seckillLoading = true;
      this.seckillFinished = false;
      this.getSeckillData([])
    },
    changeSeckill(index){
      if(this.seckillIndex==index) return false
      this.seckillIndex=index
      //请求参数
      this.seckillPageIndex = 0
      this.seckillLoading = true;
      this.seckillFinished = false;
      this.getSeckillData([])
    },
    chuxian(index) {
      // let scrollLeft ;
      // let thisLeft = lateralScroll.scrollLeft;
      // let clientWidth = document.body.offsetWidth;
      // let smallWidth = 5*lateralItem.offsetWidth - clientWidth;
      // let allIndex = this.starttime.length - 4;
      // if(allIndex<index){
      //   scrollLeft = lateralItem.offsetWidth*(allIndex) + smallWidth;
      // }else{
      //   scrollLeft = lateralItem.offsetWidth*(index);
      // }
      // clearInterval(this.movetimer);
      // this.movetimer = setInterval(()=>{
      //   let speed = Math.abs(lateralScroll.scrollLeft-scrollLeft)/4;
      //   if(parseFloat(speed)<=1) speed = 1;
      //   if(thisLeft>scrollLeft){
      //      lateralScroll.scrollLeft -= speed;
      //      if(lateralScroll.scrollLeft<=scrollLeft){
      //        clearInterval(this.movetimer);
      //      }
      //   }else if(thisLeft<scrollLeft){
      //     lateralScroll.scrollLeft += speed;
      //     if(lateralScroll.scrollLeft>=scrollLeft){
      //       clearInterval(this.movetimer);
      //     }
      //   }else{
      //     clearInterval(this.movetimer);
      //   }
      // },30);

      //this.priceArea = [];
      if(this.seckillIndex==1) return false
      this.isindex = index;
      this.seckillIndex = 0
      this.seckillPageIndex = 0
      this.seckillLoading = true;
      this.seckillFinished = false;
      this.getPageStime();
    },
    // swiper切换下标
    swipeChange(index) {
      this.swipeIndex = index;
    },
    linkType(item){
      if(item.type=='1')
      this.linkTo(`announcement?nbr=1&&type=1`)
      else if(item.type=='2')
      this.linkTo(`material`)
      else if(item.type=='3')
      this.linkTo(`explosive?nbr=${item.extra}`)
      else if(item.type=='4')
      this.linkTo(`recommend?firstNbr=${item.extra}`)
      else if(item.type=='5')
      this.linkTo(`listdetail?nbr=${item.extra}`)
      else if(item.type=='6')
      this.linkTo('securities')
      else if(item.type=='8')
      this.gameClick()
      else if(item.type=='9')
      this.linkTo('turn?gameNbr=10001');
      else if(item.type=='10')
      this.toMoreLive();
    },
    toNewArea(){
      this.$router.push({ path: "/explosive", query: { nbr: 104,supNbr:this.userInfo.nbr } });
    },
    //设置提醒
    noticeThis(nbr,index){
      // return false;
      this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_70122",
            user_nbr: this.userInfo.nbr,
            commodity_nbr: nbr
          }
      })
      .then(response => {
        this.$toast({
          message: '开抢前五分钟提醒你哦',
          duration: 2000
        });
        this.priceArea[index].warn = 1;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    //秒杀专场分享
    toMsAreaShare(){
      let that =this
      if(this.msShareAeraImage){
        this.msShareAreaShow = true;
        return false
      }
      this.createMSAreaImage();
    },
    createMSAreaImage(){
      let that = this;
      let arr = [],newArr=[]
      let commodityList = that.priceArea;
      arr = commodityList.length>6?commodityList.slice(0, 6):commodityList
      arr.forEach((item)=>{
        let obj={
          commodityLogo:item.commodity_logo,
          commodityName: encodeURIComponent(item.commodity_name),
          sellPrice: parseFloat(item.min_sell_price),
        }
        newArr.push(obj)
      })
      let toast = that.$toast.loading({
        mask: false,
        message: "图片生成中...",
        duration: 0,
      });
      let urlStr='generateAreaCommodityShareImage'
      that.$post(`/api/image/share/${urlStr}`, {
          codeUrl: that.qrCode,
          username: encodeURIComponent(that.userName),
          userHeadUrl: that.userAvatar,
          commodityList:newArr,
        })
        .then((res) => {
          toast.clear();
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              that.msShareAeraImage = resp.imageUrl
              that.msShareAreaShow = true
            }else{
              that.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          }else{
            that.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          toast.clear();
          that.$toast({
            message: "分享图合成失败，请重试",
            duration: 2000,
          });
        });
    },
    // 秒杀分享
    goMsShare(index) {
      let that =this
      this.shareScore()
      let msCommodity = this.priceArea;
      let activeItem = msCommodity[index]
      if(activeItem.shareImg){
        let option = {
          title: activeItem.share_title||activeItem.commodity_name,
          desc: activeItem.commodity_summary || "",
          link:`${location.origin}${activeItem.rule_type=='2'?'/sourceListdetail':'/listdetail'}?supNbr=${this.userInfo.nbr}&nbr=${ activeItem.nbr}`,
          images: activeItem.share_image||activeItem.commodity_logo
        };
        this.weChatShare(option);
        this.msShareImage = activeItem.shareImg
        this.msShareShow = true;
        // setTimeout(()=>{
        //   let shareBox= that.$refs.shareBox
        //   shareBox.scrollLeft=shareBox.clientWidth/2-10
        // },100)
        return false
      }
      this.msShareImage = [];
      this.createMSCommodityCode(index);
      this.msShareShow = true;
    },
    createMSCommodityCode(index){
      let that = this;
      let activeItem = that.priceArea[index]
      let toast = that.$toast.loading({
        mask: false,
        message: "图片生成中...",
        duration: 0,
      });
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page:activeItem.rule_type=='2'?'/sourceListdetail':'/listdetail',
        supNbr: that.userInfo.nbr,
        nbr: activeItem.nbr,
      }).then(res => {
         let resp = res.object.resp;
         if (res.code == "200") {
           if (resp.resp_code == "0" && resp.resp_result == "0"){
             that.msQrCode = resp.qrcode;
             that.createCommodityShareUrl(index,toast);
           }else{
              toast.clear();
              that.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
         }else{
            toast.clear();
            that.$toast({
              message: res.message,
              duration: 2000,
            });
          }
      }).catch(err => {
        toast.clear();
        that.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    createCommodityShareUrl(index,toast){
      let that = this;
      let commodityList = that.priceArea[index];
      let endTime =''
      if (commodityList.endTime != `2030-01-01 00:00:00`) {
        endTime = `${commodityList.end_time.substring(5,7)}月${commodityList.end_time.substring(8,10)}日${commodityList.end_time.substring(11,16)}结束`
      }
      let urlStr=commodityList.rule_type=='2'?'generateTXCommodityShareImage':'generateYMCommodityShareImage'
      that.$post(`/api/image/share/${urlStr}`, {
          username: encodeURIComponent(that.userName),
          userHeadUrl: that.userAvatar,
          commodityUrl: commodityList.commodity_logo,
          codeUrl: that.msQrCode,
          commodityName: encodeURIComponent(commodityList.commodity_name),
          commodityDesc: encodeURIComponent(commodityList.commodity_summary||''),
          oldPrice: commodityList.old_price,
          sellPrice: commodityList.min_sell_price,
          endTime: endTime,
        })
        .then((res) => {
          toast.clear();
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              commodityList.shareImg=[resp.imageUrl]//resp.imageUrl2,
              that.msShareImage = commodityList.shareImg
              let option = {
                title: commodityList.commodity_name,
                desc: commodityList.commodity_summary || "",
                link:`${location.origin}${commodityList.rule_type=='2'?'/sourceListdetail':'/listdetail'}?supNbr=${that.userInfo.nbr}&nbr=${ commodityList.nbr}`,
                images: commodityList.commodity_logo
              };
              that.weChatShare(option);
              // setTimeout(()=>{
              //   let shareBox= that.$refs.shareBox
              //   shareBox.scrollLeft=shareBox.clientWidth/2-10
              // },150)
            }else{
              that.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          }else{
            that.$toast({
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          toast.clear();
          that.$toast({
            message: "分享图合成失败，请重试",
            duration: 2000,
          });
        });
    },
    // canvas生成图
    screenImage(imgUrl,index){
      let that = this;
      let canvas = document.createElement('canvas');
      let homeFullImg = this.homeFullImg;
      let img = new Image();let url;
      img.crossOrigin = "Anonymous"
      img.onload = function () {
         // 画背景图
         canvas.width = 422*2;
         canvas.height = 746*2;
         let ctx=canvas.getContext("2d");
         ctx.drawImage(img,0,0,422*2,746*2);
        //  ctx.drawImage(img,0,0,422,746*(img.height/img.width)*(422/746));
         ctx.restore();
         let avatar = new Image();
         avatar.crossOrigin = "Anonymous"
         avatar.onload = function () {
           //  画头像
           ctx.save();
           ctx.beginPath();
           ctx.arc(canvas.width/2, 56*2, 36*2, 0, 2 * Math.PI);
           ctx.fill();
           ctx.clip();
           ctx.drawImage(avatar,canvas.width/2 - 36*2,20*2,72*2,72*2);
           ctx.restore();
           //  画昵称
           ctx.save();
           ctx.font = "40px sans-serif";
           ctx.textAlign="center";
           ctx.fillStyle="#ffffff";
           ctx.fillText(that.userName,canvas.width/2,120*2);
           // 画二维码
           let code = new Image();
           code.crossOrigin = "Anonymous"
           code.onload = function (){
             ctx.save();
             ctx.drawImage(code,30*2,620*2,100*2,100*2);
             ctx.restore();
             url = canvas.toDataURL('image/jpg');
             homeFullImg[index].mainImg = url;
             that.homeFullImg = homeFullImg;
             if(index == homeFullImg.length - 1){
               that.shareSwitch = false;
               clearTimeout(that.timeOut);
               setTimeout(()=>{
                 if(that.swiper){
                     that.swiper.destroy();
                  }
                  that.swiper = new Swiper ('#shareSwiper', {
                    autoplay: false,
                    autoHeight: true,
                    speed: 1000,
                    loop: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    observer:true,
                    observeParents:true,
                    loopAdditionalSlides:0,
                  })
                },200);
               that.$toast({
                 message: '图片生成成功，请长按保存图片',
                 duration: 2000
               });
             }
           }
           if(that.qrCode==''){
             that.shareSwitch = true;
             return that.$toast({
                message: '二维码获取失败，请重试',
                duration: 2000
              });
           }
           code.src = that.qrCode;
         }
         avatar.src = that.userAvatar;
       }
      img.src = imgUrl;
    },
    drawText(ctx,text,x,y,w){
       var chr = text.split("");
        var temp = "";
        var row = [];
        for(var a = 0; a < chr.length; a++){
            if( ctx.measureText(temp).width < w && ctx.measureText(temp+(chr[a])).width <= w){
                temp += chr[a];
            }
            else{
                row.push(temp);
                temp = chr[a];
            }
        }
        row.push(temp);
        // for(var b = 0; b < row.length; b++){
        //     ctx.fillText(row[b],x,y+(b+1)*34);//字体20，间隔24。类似行高
        // }
        // 只显示2行，加...
        for(var b = 0; b < row.length; b++){
            var str = row[b];
            if(b == 1&&row.length>2){
                str = str.substring(0,str.length-1) + '...';
            }
            if(b < 2){
              ctx.fillText(str,x,y+(b+1)*34);
            }
        }
    },
    // 分享朋友
    wechatShareBtn1(){
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    // 分享朋友圈
    wechatShareBtn2(){
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    shareScore(){
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow:'flow_150008',
          user_nbr: this.userInfo.nbr,
        }
      })
    },
    // 点击分享
    btn(){
      this.show = true;
      if(!this.shareSwitch){
        return false;
      }
      let that = this;
      let homeFullImg = this.homeFullImg;
      let shareSwitch = this.shareSwitch;
      let toast = that.$toast.loading({
        mask: false,
        message: '图片生成中...',
        duration: 0
      });
      that.timeOut = setTimeout(()=>{
        that.$toast({
          message: '图片生成失败',
          duration: 2000
        });
      },5000);
      homeFullImg.map((item,index)=>{
        that.screenImage(item.img,index);
      });
      that.shareScore()
    },
    // 分享弹窗关闭
    btn1(){
      this.show = false;
    },
    // 下载提示
    downloadImg(){
      this.$toast({
        message: '请长按保存图片',
        duration: 2000
      });
    },
    //更多推荐下商品
    getSecondArea() {
      let that = this;
       // 更多推荐
      this.$commonPost({
        jydm: "flow_70061",
        flow_70061: {
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
        }
      })
        .then(response => {
          let secondArr = [];
          if(response.commodityList){
              if (response.commodityList.commodity.length > 0) {
                secondArr = response.commodityList.commodity;
            } else {
                secondArr.push(response.commodityList.commodity);
            }
          }
          that.goods_classify = that.goods_classify.concat(secondArr);
          that.loading = false;
          if (secondArr.length < that.numPerPage) {
            that.finished = true;
          } else {
            that.pageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    menuClick(item){
      if(item.type=='1')
      this.linkTo(`announcement?nbr=1&&type=1`)
      else if(item.type=='2')
      this.linkTo(`material`)
      else if(item.type=='3')
      this.linkTo(`explosive?nbr=${item.extra}`)
      else if(item.type=='4')
      this.linkTo(`recommend?firstNbr=${item.extra}`)
      else if(item.type=='5')
      this.linkTo(`sourceList`)
    },
    // 跳转轮播商品详情页面
    goslidedetail(type, extra) {
      if (type == 0) {
        return false;
      } else if (type == "1") {
        window.location.href = extra
      } else if (type == "2") {
        this.$router.push({ path: "/listdetail", query: { nbr: extra,supNbr:this.userInfo.nbr } });
      }else if (type == "3") {
        this.$router.push({ path: "/explosive", query: { nbr: extra,supNbr:this.userInfo.nbr } });
      }else if (type == "4") {
        this.$router.push({ path: "/explosive", query: { nbr: extra,supNbr:this.userInfo.nbr, big:'1' } });
      }else if (type == "5") {
        this.$router.push({ path: "/sourceList", query: {supNbr:this.userInfo.nbr} });
      }
    },
    // 优惠券关闭
    couponsclose() {
      this.showcoupons = false;
      this.afterClose();
    },
    afterClose(){
      let that = this;
      let goodNbr = this.jumpParam.goodNbr||'',
        groupNbr = this.jumpParam.groupNbr||'' ,
        groupLeaderNbr = this.jumpParam.groupLeaderNbr||'',
        material = this.jumpParam.material||'',
        materialNbr = this.jumpParam.materialNbr||'';
      if (goodNbr) {
        that.mounted1 = true;
        history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
        that.$router.push({
          path: "/listdetail",
          query: { nbr: goodNbr,supNbr:this.userInfo.nbr }
        });
      }
      else if (material) {
        that.mounted1 = true;
        history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
        if(material==1){
          that.$router.push({ path: "/material" ,query:{supNbr:this.userInfo.nbr}});
        }else{
          that.$router.push({ path: "/comodityMaterial" ,query:{ nbr:material,supNbr:this.userInfo.nbr }});
        }
      }
      else if (materialNbr) {
        that.mounted1 = true;
        history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
        that.$router.push({
          path: "/materialDetail",
          query: { nbr: materialNbr,supNbr:this.userInfo.nbr }
        });
      }
    },
    showImage(img){
     wx.previewImage({
       current:img,
       urls:[img]
     })
    },
    // 优惠券领取
    getcoupon() { //id, index
      let that = this;
      if(this.couponSwitch){
        return false;
      }
      this.couponSwitch = true;
      // if (this.coupon_list[index].coupon_listshow == 1) {
      //   return false;
      // }
      // 领取新手优惠券
      let coupon_list= this.coupon_list;
      let arr = [];
      coupon_list.map(item => {
        arr.push({nbr:item.nbr});
      })
        this.$commonPost({
            jydm: "flow_70024",
            flow_70024: {
              user_nbr: this.userInfo.nbr,
              coupon: arr
            }
        })
        .then(response => {
            this.$toast({
                message: '领取成功',
                duration: 2000
            });
            this.getCoupons = true;
            this.couponSwitch = false;
            this.showcoupons = false;
            localStorage.setItem("is_new_coupon",1);
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      
    },
    // 跳转商品详情页面
    gopurchaseCommdity(nbr) {
      this.$router.push({ path: "/purchaseCommdity", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
    },
    toMoreLive(){
      // wx.miniProgram.navigateTo({
      //   url:`/pages/live/liveList`
      // })
      this.toLive()
    },
    toLive(item, index){
      if(this.xcxCode) return this.xcxCodeShow = true
      let toast = this.$toast.loading({message:'生成小程序码'})
      this.$post('api/wechat/xcx/generateQRCode',{
        scene: this.userInfo.nbr,
        page: 'pages/live/liveList',
      }).then(res=>{
         if (res.code == "200") {
            let resp = res.object.resp;
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              this.xcxCodeShow = true
              this.xcxCode = resp.qrcode
            }
         }
         toast.clear()
      }).catch(err=>{
        toast.clear()
        this.$toast({
          message: err.message,
          duration: 2000
        });
      })
      // wx.miniProgram.navigateTo({
      //   url:`/pages/live/liveRoom?state=${item.state}&roomID=${item.room_id}&roomName=${encodeURIComponent(item.room_title)}&roomNbr=${item.nbr}&userName=${this.userName}&playUrl=${encodeURIComponent(item.play_url)}`
      // })
    },
    golistdetail(nbr, rule_type) {
      if(rule_type=='2'){
        this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }else{
        this.$router.push({ path: "/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = decodeURIComponent(window.location.search.substr(1)).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //获取新手优惠券
    getNewCoupon() {
      // 新手优惠券
      this.$commonPost({
        jydm: "flow_70026",
        flow_70026: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          let arr = [];
          if (response.couponlist) {
            if (response.couponlist.length > 0) {
              arr = response.couponlist;
            } else {
              arr.push(response.couponlist);
            }
          }
          arr.forEach(item => {
            item.coupon_listshow = "0";
          });
          this.coupon_list = arr;
          if (response.count > 0) {
            this.couponsshow = true;
            this.showcoupons = true;
          }else{
            this.checkAfterUrl();
          }
        })
        .catch(err => {
//          this.$toast({
//            message: err.message,
//            duration: 2000
//          });
        });
    },
    // 微信code
    getWechatSubscribeCode() {
      let that =this
      this.$post("/api/wechat/gzh/getAccessToken",{type: this.appType})
        .then(resp => {
          if (resp.code == "200") {
            let datas = resp.object.resp;
            if (datas.resp_code == 0 && datas.resp_result == 0) {
              if(datas.wxAccessToken){
                that.getWechatSubscribe(datas.wxAccessToken);
              }
            }
          }
        }).catch(err => {
        });
    },
    getWechatSubscribe(token){
      let that = this;
      this.$fetch(
        "/weChatApi/cgi-bin/user/info?access_token=" +
        token +
        "&openid=" +
        this.openid +
        "&lang=zh_CN"
      ).then(data => {
          that.wechatSubscribe = data.subscribe
          localStorage.setItem('wechatSubscribe',data.subscribe)
        }).catch(err => {});
    },
    // 绑定推荐人
    bindSuper(shareUserNbr) {
      this.$post("/api/customer/updateSupUser", {
        userNbr: this.userInfo.nbr,
        supUserNbr: shareUserNbr
      });
    },
    // 首页刷新
    refresh(){
      this.slides = [];
      this.news = [];
      this.pageIndex = 0;
      this.shareSwitch = true;
      this.goods_classify = [];
      this.homeFullImg = [];
      this.pagearea = [];
      this.loading = false;
      this.finished = false;
      this.seckillIndex= -1;
      this.priceArea=[];
      this.seckillLoading = false;
      this.seckillFinished = false;
      if(this.swiper){
        this.swiper.destroy();
      }
      if(this.$refs.hotArea){
        // this.$refs.hotArea.map(item=>{item.getData()});
        this.$refs.hotArea.getData(0);
      }
      this.getPageData();
      this.getNewData();
      this.getNotice();
      this.getUserInfo();
    },
    priceAreatimer() {
      let date = new Date();
      let starttime = this.starttime;
      let count = 0;
      for (var i = 0; i < starttime.length; i++) {
        if(starttime[i].type=='1'){
          let toTime = starttime[i].start_time.split(":");
          let thisTime = [date.getHours(), date.getMinutes()];
          if (Number(toTime[0]) > Number(thisTime[0])) {
            starttime[i].timeText = false;
          } else if(Number(toTime[0]) == Number(thisTime[0])) {
            if(Number(toTime[1]) > Number(thisTime[1])){
                  starttime[i].timeText = false;
                }else{
                  starttime[i].timeText = true;
                  count += 1;
                }
          }else{
            starttime[i].timeText = true;
            count += 1;
          }
        }else{
            starttime[i].timeText = false;
        }
      }
      if(count == 0){
        this.isindex = 0;
      }else{
        this.isindex = count - 1;
      }
      this.starttime = starttime;
      setTimeout(()=>{
        this.chuxian(this.isindex);
        // let lateralScroll = document.getElementById('lateralScroll');
        // let lateralItem = document.getElementById('lateralItem0');
        // let scrollLeft  = lateralItem.offsetWidth*(this.isindex);
        // lateralScroll.scrollLeft = scrollLeft;
        // this.times();
        // this.claerTimer = setInterval(() => {
        //   this.times();
        // }, 1000);
      },30);
    },
    getPageStime(){
      let that = this;
       this.$commonPost({
          jydm: "flow_70013",
          flow_70013: {
            area_nbr: "103",
            user_nbr:that.userInfo.nbr||"",
            page_index: "0",
            num_per_page: this.numPerPage,
            type:this.starttime[this.isindex].type,
            start_time:this.starttime[this.isindex].start_time
          }
        })
        .then(response => {
          let arr1 = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr1 = response.commodity;
            } else {
              arr1.push(response.commodity);
            }
          }
          this.priceArea = arr1;
          if(arr1.length<=0){
            this.starttime[this.isindex].isEnd = true;
          }else{
            this.starttime[this.isindex].isEnd = false;
          }
          this.seckillLoading = false;
          if (arr1.length < that.numPerPage) {
            this.seckillFinished = true;
          } else {
            this.seckillPageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
      });
    },
    timeer(){
      let oneTime = this.starttime;
      oneTime.forEach((item,index)=>{
        if(oneTime[index].timeText==false){
          if(this.thisIndex==''){
            this.thisIndex = index;
          }
          return false
        }
      })
    },
    times() {
      let date = new Date();
      let date1 = new Date();
      let string = this.starttime;
      var newStr = '';
      let thisTimes = `${date1.getFullYear()}/${date1.getMonth() +
        1}/${date1.getDate()} ${date1.getHours()}:${date1.getMinutes()}:${date1.getSeconds()}`;
      let starttimes = thisTimes.replace(/\-/g, "/");
      string[this.isindex].end_time = string[this.isindex].end_time.replace(/\-/g, "/");
      if (date1.getDate() < 10) {
        newStr =
          starttimes.slice(0, 9) + ' ' +
          string[this.isindex].start_time +
          ":00";
      } else {
        newStr =
          starttimes.slice(0, 10) + ' ' +
          string[this.isindex].start_time +
          ":00";
      }
      let thisTime = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTampStart = parseInt(new Date(newStr) - new Date(thisTime)) / 1000;
      let timeTampEnd = parseInt(new Date(string[this.isindex].end_time) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTampStart <= 0) {
        if(timeTampStart == 0){
          string[this.isindex].timeText = true;
          return this.refresh();
        }
        if(timeTampEnd <= 0){
          string[this.isindex].isEnd = true;
          return this.refresh();
        }
        timeText = `${this.addZero(
          parseInt((timeTampEnd % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTampEnd % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTampEnd % 60))}`;
        this.isStart = 1;
      } else {
        timeText = `${this.addZero(
          parseInt((timeTampStart % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTampStart % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTampStart % 60))}`;
        this.isStart = 0;
      }
      this.countdown = timeText;
    },
    addZero(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    getHotArea(index){
      this.$commonPost({
          jydm: "flow_70060",
          flow_70060: {
            home_nbr:"1",
            type: "1",
            page_index: index,
            num_per_page: "10"
          }
        })
        .then(response => {
          let arr = [];
          if(response.area){
            if (response.area.length > 0) {
              arr = response.area;
            } else {
              arr.push(response.area);
            }
          }
          this.pagearea = this.pagearea.concat(arr);
          if(arr.length == 10){
            this.getHotArea(( index+1 ) * 10)
          }
        })
        .catch(err => {
//            this.$toast({
//              message: err.message,
//              duration: 2000
//            });
        });
    },
    // 获取页面资源
    getPageData() {
      let that = this;
      setTimeout(() => {
        that.isLoading = false;
      }, 500);
      // 首页轮播
      this.$commonPost({
        jydm: "flow_70046",
        flow_70046: {
          home_nbr: "1",
          state: "0",
          page_index: "0",
          num_per_page: "10"
        }
      })
        .then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if(response.image){
              if (response.image.length > 0) {
                arr = response.image;
              } else {
                arr.push(response.image);
              }
            }
          }
          this.slides = arr;
          this.bgColor = arr[0].color||'#E52B25'
          setTimeout(()=>{
            if(this.swiperTop){
              this.swiperTop.destroy();
            }
            if(this.slides.length>0){
              this.swiperTop = new Swiper ('.swiper-top', {
                autoplay: 3000,
                autoHeight: true,
                speed: 1000,
                loop: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                observer:true,
                observeParents:true,
                loopAdditionalSlides:0,
                autoplayDisableOnInteraction:false,
                onSlideChangeStart:function(swiper){
                  that.swipeIndex = swiper.activeIndex % that.slides.length;
                  that.bgColor = that.slides[that.swipeIndex].color||'#E52B25'
                },
                onClick:function(swiper){
                  let slide = that.slides[that.swipeIndex]
                  that.goslidedetail(slide.type,slide.extra)
                }
              })
            }
          },200);
        })
        .catch(err => {
//          this.$toast({
//            message: err.message,
//            duration: 2000
//          });
        });
  
      this.$commonPost({
        jydm: "flow_90006",
        flow_90006: {
          game_nbr: "10000"
        }
      }).then(response => {
        that.gameState = response.active
      }).catch(err => {});
  
      this.$commonPost({
        jydm: "flow_70169",
        flow_70169: {
          nbr: '1',
        }
      }).then(response => {
        that.couponCenterObj = response
      }).catch(err => {});

      //公告内容
      this.$commonPost({
        jydm: "flow_70203",
        flow_70203: {
          type:'1',
          page_index: 0,
          num_per_page: 10,
        }
      })
        .then(response => {
        let arr = [];
        if(response.list){
          if(response.list.length > 0){
            arr = response.list
          }else{
            arr.push(response.list)
          }
        }
        let noticeObj = arr[0]||{}
        let str =  (noticeObj.contents||'') //+ (noticeObj.image_url?'  [图片]':'')
        let newStr = str
        if(str){
          for(let i=0;i<100;i++){
            newStr+='\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+str
          }
        }
        this.noticeObj = arr[0]||{}
        this.noticeStr = newStr
      })
      .catch(err => {});

             //直播
      this.$commonPost({
        jydm: "flow_70165",
        flow_70165: {
          home_nbr: 1,
          state: 0,
          page_index: 0,
          num_per_page: 20,
        }
      })
         .then(response => {
          let arr = [];
          if(response.image){
            if (response.image.length > 0) {
              arr = response.image;
            } else {
              arr.push(response.image);
            }
          }
          this.menuArr = arr;
        })
        .catch(err => {
//          this.$toast({
//            message: err.message,
//            duration: 2000
//          });
        });

           //直播
      this.$commonPost({
        jydm: "flow_110036",
        flow_110036: {
          user_nbr: this.userInfo.nbr,
          live_status: 0,
          page_index: 0,
          num_per_page: 1,
        }
      })
         .then(response => {
          let arr = [];
          if(response.liveroom){
            if (response.liveroom.length > 0) {
              arr = response.liveroom;
            } else {
              arr.push(response.liveroom);
            }
          }
          this.liveList = arr;
        })
        .catch(err => {
//          this.$toast({
//            message: err.message,
//            duration: 2000
//          });
        });

          //新人专享
      this.$commonPost({jydm: "flow_70013",flow_70013: {
          area_nbr: "104",
          page_index: "0",
          num_per_page: "10",
          type:"-1",
      }}).then(response => { this.newShow = (response.commodity&& response.commodity > 0)}).catch(err => { });

        //热门专场
        this.getHotArea(0)

        //今日秒杀
      // this.$commonPost({
      //   jydm: "flow_70013",
      //   flow_70013: {
      //     area_nbr: "103",
      //     page_index: "0",
      //     num_per_page: "10",
      //     type:"1",
      //   }
      // })
      //   .then(response => {
      //     let arr = [];
      //    if (response.total_rows > 0) {
      //       if(response.commodity){
      //         if (response.commodity.length > 0) {
      //           arr = response.commodity;
      //         } else {
      //           arr.push(response.commodity);
      //         }
      //         this.notice = arr;
      //       }
      //     }
      //   })
      //   .catch(err => {
      //    this.$toast({
      //      message: err.message,
      //      duration: 2000
      //    });
      //   });
        // 秒杀
        this.getTimeArea();

        this.getOffShelf();

        //分享图片列表
        this.$commonPost({
            jydm: "flow_70066",
            flow_70066: {
                page_index: 0,
                num_per_page: 6,
            }
          })
          .then(response => {
            let arr = []; let newArr = [];
             //homeFullImg
            if (response.total_rows > 0) {
              if(response.image){
                if (response.image.length > 0) {
                  arr = response.image;
                } else {
                  arr.push(response.image);
                }
                arr.map(item => {
                  let obj = {
                    nbr: item.nbr,
                    img: item.image_path,
                    mainImg: '',
                  }
                  newArr.push(obj);
              })
              }
            }
            this.homeFullImg = newArr;
          })
          .catch(err => {
//            this.$toast({
//                message: err.message,
//                duration: 2000
//            });
          });
    },
    // 动态提示变化下标
    changeNewIndex() {
      this.randomNum = this.random(1,6);
      this.buyshow = true;
      this.newIndex += 1;
      setTimeout(()=>{
        this.buyshow = false;
      },3000);
    },
    getNotice(){
      this.$commonPost({
        jydm: "flow_70206",
        flow_70206: {
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((resp) => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            this.hasMessage = resp.total_rows
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    // 获取动态提示
    getNewData(){
     let that = this;
     this.newIndex = -1;
     clearInterval(that.timer);
     clearTimeout(that.timerOut);
     that.timerOut = setTimeout(()=>{
        //查询最近10条订单用户信息
      that.$commonPost({
        jydm: "flow_70063",
        flow_70063: {
        }
      })
        .then(response => {
          let arr = [];
          if (response.user) {
            if (response.user.length > 0) {
              arr = response.user;
            } else {
              arr.push(response.user);
            }
            arr.map(item=>{
              item.nick_nam = this.checkName(item.nick_nam);
            })
            that.news = that.news.concat(arr);
          }
        })
        .catch(err => {
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
        that.changeNewIndex();
        that.timer = setInterval(()=>{
          if(that.newIndex>=9)
            return clearInterval(that.timer);
          that.changeNewIndex();
        },7000);
      },10000);
    },
    handleScroll(){
      // 设备/屏幕高度
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 50){
        this.toTopShow = true;
      }else{
        this.toTopShow = false;
      }

      // let swiperTop = document.getElementById("serverTime").offsetTop;
      // if(scrollTop>swiperTop){
      //   this.stopBg=true
      // }else{
      //   this.stopBg=false
      // }

      if(this.starttime.length>0||this.offShelf){
        let seckillWrapTop = document.getElementById("seckillWrap").offsetTop;
        let seckillEndTop = document.getElementById("seckillEnd").offsetTop;
        if (scrollTop >= seckillWrapTop&&scrollTop<seckillEndTop) {
          this.msShow = true;
        } else {
          this.msShow = false;
        }
      }
    },
    // 回到顶部动画
    toTopAnimate(){
      window.scrollTo(0,0);
    },
    checkName(name){
      let result = '';
      let nameArr = name.split('');
      //let length = name.replace(/[\u0391-\uFFE5]/g,"aa").length;
      if(nameArr.length >= 2){
        result = nameArr[0] + '**' + nameArr[nameArr.length - 1] + '在';
      }else{
        result = name + '在';
      }
      return result;
    },
    random(lower, upper) {
	    return Math.floor(Math.random() * (upper - lower)) + lower;
    },
    // 生成二维码
    createCode(){
      let that = this;
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page:'/index',
        supNbr: that.userInfo.nbr,
      }).then(res => {
         let resp = res.object.resp;
         if (res.code == "200") {
           if (resp.resp_code == "0" && resp.resp_result == "0"){
             that.qrCode = resp.qrcode;
             this.setQrCode(resp.qrcode)
             clearInterval(that.codeTimer);
           }
         }
      }).catch(err => {

      });
    },
    setQrCode(code){
      this.$commonPost({
        jydm: "flow_10078",
        flow_10078: {
          user_nbr: this.userInfo.nbr,
          qr_code: code
        }
      }).then(()=>{}).catch(()=>{})
    },
    checkAfterUrl(){
      let that = this;
      let goodNbr = this.jumpParam.goodNbr||'',
        groupNbr = this.jumpParam.groupNbr||'' ,
        groupLeaderNbr = this.jumpParam.groupLeaderNbr||'',
        material = this.jumpParam.material||'',
        materialNbr = this.jumpParam.materialNbr||'';
      setTimeout(()=>{
        if (goodNbr) {
          that.mounted1 = true;
          history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
          that.$router.push({
            path: "/listdetail",
            query: { nbr: goodNbr,supNbr:this.userInfo.nbr }
          });
        }
        else if (material) {
          that.mounted1 = true;
          history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
          if(material==1){
            that.$router.push({ path: "/material" ,query:{supNbr:this.userInfo.nbr}});
          }else{
            that.$router.push({ path: "/comodityMaterial" ,query:{ nbr:material,supNbr:this.userInfo.nbr }});
          }
        }
        else if (materialNbr) {
          that.mounted1 = true;
          history.replaceState(null, null, location.origin+'/index?supNbr='+this.userInfo.nbr);
          that.$router.push({
            path: "/materialDetail",
            query: { nbr: materialNbr,supNbr:this.userInfo.nbr }
          });
        }
      },500);
    },
    getUserInfo(){
      let that = this
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          if(!response.sup_nbr && that.shareUserNbr){
            that.bindSuper(that.shareUserNbr)
          }
          if(response.role == 2|| response.role == 3) that.getGroupInfo()
          if (response.role == 0||response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }
          if (response.new_role == 0 || response.new_role == 1) {
            this.roleNewText = "sell";
          } else if (response.new_role == 2) {
            this.roleNewText = "agent";
          } else if (response.new_role == 3) {
            this.roleNewText = "director";
          }
          //this.roleText = "sell";
          this.userName = response.nick_name
          this.userAvatar = response.head_pic
          this.subUserName = response.sup_nick_name
          this.subUserImg = response.sup_head_pic
          if(!response.qr_code){
            this.createCode();
            clearInterval(this.codeTimer);
            this.codeTimer = setInterval(()=>{
              this.createCode();
            },6000);
          }else{
            this.qrCode = response.qr_code;
          }
          if(this.mounted1){
            return this.mounted1 = false;
          }
          let option = {
            title: '有米@'+this.userInfo.name+'的店铺',
            desc: "欢迎光临我的店铺",
            link: location.origin + "/?supNbr=" + this.userInfo.nbr,
            images: this.userInfo.imgUrl,
          };
          let isLogin = 1;
          this.isLogin = isLogin;
          this.weChatShare(option);
          
          if(localStorage.getItem('otherConfig_10006')!=1){
            return false;
          }
        })
        .catch(err => {
          // this.$toast({
          //   message: err.message,
          //   duration: 2000
          // });
        });
    },
    titleNameCheck(name){
      let result = '';let count = 0;
      let nameArr = name.split('');
      let length = name.replace(/[\u0391-\uFFE5]/g,"aa").length;
      if(length >= 14){
        for(let i=0; i<14 ; i++){
          if(count<=14){
            if(/[\u0391-\uFFE5]/g.test(nameArr[i])){
              count += 2;
            }else{
              count += 1;
            }
            if(count>14){
              result += '...';
            }else{
              result += nameArr[i];
            }
          }
        }
      }else{
        result = name;
      }
      return result;
    },
    agentLevel(){
      //是否开启邀请角色升级活动
          this.$commonPost({
            jydm: "flow_10052",
            flow_10052: {
            }
          })
          .then(response => {
              this.fans = response;
          })
          .catch(err => {
              this.$toast({
                  message: err.message,
                  duration: 2000
              });
          });
    },
    getOffShelf(){
      let that = this;
      this.$commonPost({
        jydm: "flow_70013",
        flow_70013: {
          'area_nbr':'108',
          page_index: "0",
          num_per_page: "10",
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          if(arr.length>0){
            that.offShelf=true
          }else{
            that.offShelf=false
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getTimeArea(){
      let that = this;
      this.$commonPost({
        jydm: "flow_70064",
        flow_70064: {
          area_nbr: '103',
          type:'1'
        }
      })
        .then(response => {
          let arr = [];
          if (response.fullTime) {
            if (response.fullTime.length > 0) {
              arr = response.fullTime;
            } else {
              arr.push(response.fullTime);
            }
          }
          arr.forEach((item,index)=>{
            item.type='1'
          })
          if(arr.length>3) arr = arr.slice(0,3)
          that.starttime = arr;
          this.getTomorrowTime();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getTomorrowTime(){
      let that = this;
      // 明日
        this.$commonPost({
        jydm: "flow_70064",
        flow_70064: {
          area_nbr: "103",
          type: 2
        }
      })
        .then(response => {
          let arr = [];
          if (response.fullTime) {
            if (response.fullTime.length > 0) {
              arr = response.fullTime;
            } else {
              arr.push(response.fullTime);
            }
          }
          arr.forEach((item,index)=>{
            item.type='2'
            item.timeText=false
          })
          if(arr.length>0&&that.starttime.length<3){
             that.starttime.push(arr[0])
          }
          if(that.starttime.length>0){
            this.priceAreatimer();
            this.timeer();
          }else{
            that.changeSeckill(1)
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    //秒杀下商品、待下架商品
    getSeckillData(newArr) {
      let that = this;
      let priceArea = newArr?newArr:this.priceArea
      if(this.seckillIndex==0){
        this.$commonPost({
          jydm: "flow_70013",
          flow_70013: {
            area_nbr: "103",
            user_nbr:that.userInfo.nbr||"",
            page_index: this.seckillPageIndex*this.numPerPage,
            num_per_page: this.numPerPage,
            type:this.starttime[this.isindex].type,
            start_time:this.starttime[this.isindex].start_time
          }
        })
        .then(response => {
          let arr1 = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr1 = response.commodity;
            } else {
              arr1.push(response.commodity);
            }
          }
          that.priceArea = priceArea.concat(arr1);
          that.seckillLoading = false;
          if (arr1.length < that.numPerPage) {
            that.seckillFinished = true;
          } else {
            that.seckillPageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
      });
      }else if(this.seckillIndex==1){
      this.$commonPost({
        jydm: "flow_70013",
        flow_70013: {
          'area_nbr':'108',
          page_index: this.seckillPageIndex*this.numPerPage,
          num_per_page: this.numPerPage,
        }
      })
        .then(response => {
          let secondArr = [];
          if(response.commodity){
              if (response.commodity.length > 0) {
                secondArr = response.commodity;
            } else {
                secondArr.push(response.commodity);
            }
          }
          that.priceArea = priceArea.concat(secondArr);
          that.seckillLoading = false;
          if (secondArr.length < that.numPerPage) {
            that.seckillFinished = true;
          } else {
            that.seckillPageIndex += 1;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
      }
    },
    platformClick(){
      this.$toast({
        message: '敬请期待！',
        duration: 2000
      });
    },
    gameClick(){
      this.linkTo('turn');
    },
    configAjax(){
      this.$commonPost({
        jydm: "flow_10060",
        flow_10060: {
        }
      })
        .then(response => {
          let arr = [];
          if(response.config){
            if(response.config.length>0){
              arr = response.config;
            }else{
              arr.push(response.config);
            }
          }
          arr.map(item=>{
           // 其余参数
           localStorage.setItem(`otherConfig_${item.nbr}`,item.value);
          })
          this.recommendShow = localStorage.getItem('otherConfig_10010');
          this.wechatLikeSwitch = localStorage.getItem('otherConfig_10016');
          this.show_word_version = localStorage.getItem('otherConfig_10008');
          this.is_show_list_in_home = localStorage.getItem('otherConfig_10042');
          this.afterCheckConfig();
        })
        .catch(err => {
          let arr = ['10000','10001','10002','10003','10004',
          '10005','10006','10007','10008','10009','10010','10011']
          arr.map(item=>{
            // 其余参数
            localStorage.setItem(`otherConfig_${item}`,0);
            //this.recommendShow = localStorage.getItem('otherConfig_10010');
          })
          this.afterCheckConfig();
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    afterCheckConfig(){
      let is_new_coupon = localStorage.getItem("is_new_coupon");
      this.getPageData();
      if (is_new_coupon == "0") {
        return this.getNewCoupon();
      }
      this.checkAfterUrl();
     },
    getCardState(){
      let that = this
      let isHomeShowCard = sessionStorage.getItem(`otherConfig_10033`);
      this.$commonPost({
        jydm: "flow_10106",
        flow_10106: {
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((response) => {
          if(isHomeShowCard=='1'&&response.state=='2'){
            that.showEquity = true;
          }else{
            that.showEquity = false;
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    closeHomePopup(item){
      item.modalState=false
      this.popupArr = this.popupArr
    },
    getHomePopup(){
      let that = this
      let showNewCard = sessionStorage.getItem("showHomePopup");
      if(showNewCard!='1'){
        that.$commonPost({
          jydm: "flow_70232",
          flow_70232: {
            home_nbr: 1,
            state: 0,
            page_index: 0,
            num_per_page: 20,
          }
        })
        .then(response => {
          let arr = [];
          if(response.image){
            if (response.image.length > 0) {
              arr = response.image;
            } else {
              arr.push(response.image);
            }
          }
          if(arr.length>0){
            arr = arr.filter((item)=>{return item.type!='7'&&item.type!='9'})
            arr.forEach((item)=>{
              item.modalState=true
            })
            that.popupArr = arr;
            that.homePopupModal=true
          }
          sessionStorage.setItem("showHomePopup",'1')
        })
        .catch(err => {
        });
      }
    },
    getEquityCard(){
       let that = this
      if(this.userInfo&&this.userInfo.nbr){
        let showNewCard = sessionStorage.getItem("showNewCard");
        let isHomeShowCard = sessionStorage.getItem(`otherConfig_10033`);
        if(isHomeShowCard=='1' && showNewCard=='0'){
          that.$commonPost({
            jydm: "flow_10106",
            flow_10106: {
                user_nbr: that.userInfo.nbr,
            }
          })
          .then(response => {
              if(response.state=='2'){
                that.equityModal = true;
                sessionStorage.setItem("showNewCard",'1')
              }
          })
          .catch(err => {
          });
        }
      }
    },
    getGroupInfo(){
       let that = this
      if(this.userInfo&&this.userInfo.nbr){
        let time = new Date().getTime();
        let today = timestampconvert(time / 1000); 
        let showGroup = sessionStorage.getItem("showGroup");
        let groupDateNum = localStorage.getItem("groupDateNum");
        groupDateNum=groupDateNum?JSON.parse(groupDateNum):{}
        that.$commonPost({
          jydm: "flow_30064",
          flow_30064: {
          }
        })
        .then(response => {
          let num=0
          if(today == groupDateNum.date) num= parseFloat(groupDateNum.num)
          num++
          let obj={
            date:today,
            num:num
          }
          localStorage.setItem("groupDateNum",JSON.stringify(obj));
          that.groupInfo=response
          // if(num<=1&&response.state=='0'&&showGroup=='0'){
          //   that.groupModal = true;
          //   sessionStorage.setItem("showGroup",'1')
          // }
        })
        .catch(err => {
        });
      }
    },
  },
  created() {
    this.openid=localStorage.getItem("openid");
    if(localStorage.getItem('wechatSubscribe')){
      this.wechatSubscribe = localStorage.getItem('wechatSubscribe')
    }
  
    if(this.userInfo&&this.userInfo.nbr){
      let shareUserNbr='',goodNbr, groupNbr , groupLeaderNbr, material, materialNbr;
      if(this.getUrlParam("id")){
        let paramData = this.getUrlParam("id").split(',');
        shareUserNbr = paramData[0];
        goodNbr = paramData[1];
        groupNbr = paramData[2];
        groupLeaderNbr = paramData[3];
      }
      else if(this.getUrlParam("userId")){
        shareUserNbr = this.getUrlParam("userId");
        material = this.getUrlParam("material");
        materialNbr = this.getUrlParam("materialNbr");
      }
      let obj = {
        goodNbr:goodNbr,
        groupNbr:groupNbr,
        groupLeaderNbr:groupLeaderNbr,
        material:material,
        materialNbr:materialNbr
      }
      this.shareUserNbr = shareUserNbr
      this.jumpParam = obj
    }

    setTimeout(()=>{
      this.getHomePopup()
      this.getEquityCard()
    },0)
    
    // this.agentLevel();
    this.configAjax();
    this.getWechatSubscribeCode();
  },
  activated() {
    window.addEventListener('scroll', this.handleScroll, true);
    window.scrollTo(0, this.scroll);
    this.news = [];
    this.getNewData();
    this.getNotice()
    this.isLogin = 1;
    document.title = "有米日记";
    this.getUserInfo();
    let lateralScroll = document.getElementById('lateralScroll');
    if(lateralScroll){
      lateralScroll.scrollLeft = this.scrollLeft;
    }
    setTimeout(()=>{
      this.getCardState()
    },0)
  },
  beforeRouteLeave(to, from, next){
    let lateralScroll = document.getElementById('lateralScroll');
    if(lateralScroll){
     this.scrollLeft = lateralScroll.scrollLeft;
    }
    this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener('scroll', this.handleScroll, true);
    next();
  },
  deactivated(){
      // clearInterval(this.claerTimer);
      // this.claerTimer=null
    },
  mounted() {
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less' src="./index.css"></style>
<style lang="stylus" scoped>
#refresh2 >>> .van-pull-refresh__track{
  top: 0.8rem;margin-bottom: 1.94rem;
}
.roleArea >>> .van-popup {
  top:auto;background-color: transparent;bottom:.3rem;
  transform: translate3d(-50%,0,0);overflow-y: inherit;
}
.home-top-banner >>> .carousel-3d-container {
  width: 100% !important;height: 4rem !important;
}

.home-top-banner >>> .carousel-3d-slider {
  width: 6.7rem !important;height: 4rem !important;
}

.home-top-banner >>> .carousel-3d-slide {
  width: 6.7rem !important;height: 4rem !important;
  border: none !important;
}

.home-top-banner >>> .carousel-3d-slider img {
  width: 100% !important;height: 4rem !important;
}

.home-content-tab >>> .van-tabs__line {
  background-color: #5045D8 !important;
}

.home-content-tab >>> .van-tab--active {
  color: #5045D8 !important;
}

.supervaluel >>> .van-swipe__indicator {
  width:0.3rem;height:0.04rem;
  background: #CCCCCC;
  border-radius: 0.065rem;
}

.supervaluel >>> .van-swipe__indicator--active{
  width:0.3rem;height:0.04rem;background: #FF0000;
  border-radius: 0.065rem;
}

.supervaluel >>> .van-swipe{
  height: 3rem;
}
.wrapper >>> .van-icon{
  margin-right: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue